import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { BrokerConsultantBanner } from '../../components/BrokerConsultantBanner';
import { BrokerConsultantBannerButtonContainer } from '../BrokerConsultantBannerButtonContainer';
import { trackBannerShow } from './tracking';

export const BrokerConsultantBannerContainer: React.FC = () => {
  return (
    <ActionAfterViewObserver callback={trackBannerShow}>
      <BrokerConsultantBanner button={<BrokerConsultantBannerButtonContainer />} />
    </ActionAfterViewObserver>
  );
};
